// USDT
export const DEFAULT_INPUT_CURRENCY = '0x02F9Bebf5E54968D8Cc2562356C91ECDE135801B'
// BUSD
export const DEFAULT_OUTPUT_CURRENCY = 'BNB'
